import Rangliste from "./Rangliste";
import Sheet from "./Sheet";
import { rangliste } from "../spieler";

/**
 * Volle Punktetabelle als Sheet (Mitspieler: nur ansehen).
 * eintraege: [{ key, name, score }], ich: eigener Name oder null.
 * @category spiel
 */
export function PunkteSheet({ eintraege, ich = null, farbe, onClose }) {
  const liste = rangliste(eintraege);
  const spitze = liste[0]?.score || 0;
  return (
    <Sheet titel="Punktestand" onClose={onClose}>
      <Rangliste
        farbe={farbe}
        eintraege={liste.map((e) => ({
          key: e.key ?? e.name,
          name: e.name,
          platz: e.platz,
          wert: e.score,
          sieg: spitze > 0 && e.score === spitze,
          ich: ich !== null && e.name === ich,
        }))}
      />
    </Sheet>
  );
}

export default PunkteSheet;
